import { Dropdown as CssModulesDropdown } from '@sunwebgroup/uds-ui/dropdown'
import { styled } from 'styled-components'

export const Trigger = Object.assign(
  styled(CssModulesDropdown.Trigger)``,
  { displayName: 'Dropdown.Trigger' },
)

export const Item = Object.assign(
  styled(CssModulesDropdown.Item)``,
  { displayName: 'Dropdown.Item' },
)

export const Content = Object.assign(
  styled(CssModulesDropdown.Content)``,
  { displayName: 'Dropdown.Content' },
)

export const Root = Object.assign(
  styled(CssModulesDropdown.Root)``,
  { displayName: 'Dropdown.Root' },
)

export const EmptyValueItem = Object.assign(
  styled(CssModulesDropdown.EmptyValueItem)``,
  { displayName: 'Dropdown.EmptyValueItem' },
)
